
export default {
    name: 'sidebar',
    components: {},
    props: [],
    data () {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            coupon_filter: {
                month: "",
                one_date: "",
                from_date: "",
                to_date: "",
                is_all: true
            }
        }
    },

    watch: {
        discount_observer() {
            this.countCoupon(this.coupon_filter)
        },

        cancellation_observer() {
            this.getCancellationRequest()
        },

        activeRole() {
            if (this.activeRole.nom == 'ROLE_ADMINISTRATEUR') {
                this.countCoupon(this.coupon_filter)
                this.getCancellationRequest()
            }
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
        
        activeRole(){
            return this.$store.getters['activeRole'];
        },

        discount_observer() {
            return this.$store.getters["discount_observer"];
        },

        global_discount_number() {
            return this.$store.getters["global_discount_number"];
        },

        cancellation_observer() {
            return this.$store.getters["cancellation_observer"];
        },

        global_cancellation_request() {
            return this.$store.getters["global_cancellation_request"];
        },
    },

    mounted () {
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;
        }

        this.countCoupon(this.coupon_filter)
        this.getCancellationRequest()
    },

    methods: {
        countCoupon(data) {
            this.$store.dispatch('countDiscount', data)
        },

        getCancellationRequest() {
            this.$store.dispatch('countCancellationRequest')
        },
    }
}